// extracted by mini-css-extract-plugin
export default {"code":"app-core-components-Code-Code-module__code"};